import { Component } from '@angular/core';
import { CognitoAuthService, UserPermission } from '@techspert-io/auth';
import { ISideBarRoute } from './nav-menu-link/nav-menu-link.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: 'sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent {
  sidebarToggle = false;

  private routeList: ISideBarRoute[] = [
    {
      label: 'Clients',
      icon: 'people_outline',
      route: '/admin/clients',
    },
    {
      label: 'Cognisearch',
      icon: 'search',
      route: '/admin/sourcing/cognisearch',
    },
    {
      label: 'Manual upload',
      icon: 'manage_search',
      route: '/admin/manual-upload',
    },
    {
      label: 'Target lists',
      icon: 'list_alt',
      route: '/admin/sourcing/target-list',
    },
    {
      label: 'Templates',
      icon: 'drafts',
      route: '/admin/outreach-templates',
    },
    {
      label: 'Users',
      icon: 'assignment_ind',
      route: '/admin/users',
    },
    {
      label: 'Pending payments',
      icon: 'payments',
      route: '/admin/finance/pending-payments',
      permissions: [
        UserPermission.FinanceRead,
        UserPermission.PaymentBatchesRead,
      ],
    },
    {
      label: 'Payment batches',
      icon: 'assured_workload',
      route: '/admin/finance/payment-batches',
      permissions: [
        UserPermission.FinanceRead,
        UserPermission.PaymentBatchesRead,
      ],
    },
    {
      label: 'Project payments',
      icon: 'payment',
      route: '/admin/project-payments',
    },
    {
      label: 'Out of project payments',
      icon: 'payments',
      route: '/admin/payments',
    },
    {
      label: 'Panels',
      icon: 'recent_actors',
      route: '/admin/panels',
      permissions: [UserPermission.RolodexRead],
    },
    // [ENG-2922] hidden until the project tracker can be reviewed
    // {
    //   label: 'Project tracker',
    //   icon: 'track_changes',
    //   route: '/admin/project-tracker',
    //   permissions: [UserPermission.ProjectTrackerRead],
    // },
    {
      label: 'Merge jobs',
      icon: 'merge_type',
      route: '/admin/experts/merge-jobs',
      permissions: [UserPermission.ProfileTasksRead],
    },
  ];

  get routes() {
    const user = this.cognitoAuthService.loggedInUser;

    return this.routeList.filter(
      ({ permissions }) =>
        !permissions ||
        permissions.every((permission) => user?.permissions.has(permission))
    );
  }

  get showSanta() {
    return new Date().getMonth() === 11;
  }

  constructor(private cognitoAuthService: CognitoAuthService) {}

  toggleSidebar() {
    this.sidebarToggle = !this.sidebarToggle;
  }

  logout() {
    this.cognitoAuthService.logOut().subscribe();
  }
}
